enum DocumentFormFieldNames {
  // Section titles (customRender only)
  BasicInformationTitle = 'basicInformationTitle',
  DocumentIdentificationTitle = 'documentIdentificationTitle',
  AccessValidationTitle = 'accessValidationTitle',
  OperationalScopeTitle = 'operationalScopeTitle',
  LifecycleTitle = 'lifecycleTitle',
  // Basic information
  Attachment = 'attachmentAttached',
  AiAutofillRow = 'aiAutofillRow',
  Name = 'name',
  Description = 'description',
  Category = 'categoryId',
  DocumentPermissionsTitle = 'documentPermissionsTitle',
  AllowDownload = 'allowDownload',
  AllowPrint = 'allowPrint',
  // Document identification
  Code = 'code',
  Tags = 'documentationTags',
  // Access & validation
  Sectors = 'sectorIds',
  Sites = 'siteIds',
  Approver = 'approverId',
  // Operational scope
  Equipment = 'assetIds',
  Areas = 'areaIds',
  FormTemplates = 'formTemplateIds',
  Tasks = 'taskIds',
  // Lifecycle – Renewal reminder (grouped via FrequencyFormFieldsWrapper)
  RenewalReminder = 'renewalReminder',
  RenewalReminderEnabled = 'renewalReminder_enabled',
  RenewalReminderDeadlineDate = 'renewalReminderDeadlineDate',
  RenewalReminderRepetitionTitle = 'renewalReminderRepetitionTitle',
  RenewalReminderRepetition = 'renewalReminderRepetition',
  RenewalReminderCustomDays = 'renewalReminderCustomDays',
  RenewalReminderEarlyReminderTitle = 'renewalReminderEarlyReminderTitle',
  RenewalReminderEarlyAmount = 'renewalReminderEarlyAmount',
}

export default DocumentFormFieldNames;
